// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/emergency-procedures-general.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/emergency-procedures-general/emergency-procedures-general.js';

mount([g0]);
